import { createApiSlice } from 'app/createApiSlice'
import {
  API_DISBURSEMENT_AUTO_CALCULATE,
  API_DISBURSEMENT_BATCH,
  API_DISBURSEMENT_BATCH_DETAIL,
  API_DISBURSEMENT_BATCH_DETAIL_LIST,
  API_DISBURSEMENT_DETAILS,
  API_DISBURSEMENT_HISTORY_LIST,
  API_PROJECT_SUMMARY_DASHBOARD,
  API_TEAMS,
} from 'utils/apiList'

export const employeePaymentsListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'employeePaymentsList/api',
  endpoints(builder) {
    return {
      fetchEmployeePaymentsList: builder.query({
        query({ projectId }) {
          return {
            url: `/${API_PROJECT_SUMMARY_DASHBOARD}/${projectId}`,
          }
        },
      }),
      fetchTeamList: builder.query({
        query(payload) {
          let url = `/${API_TEAMS}`

          return {
            url,
            params: {
              page: payload.page ?? 0,
              size: payload.size ?? 9999,
              sortby: payload.sortby ?? 'name',
              sortdir: payload.sortdir ?? 'asc',
              s: payload.search ?? '',
            },
          }
        },
      }),
      fetchDisburseHistoryList: builder.query({
        query(payload) {
          let url = `/${API_DISBURSEMENT_HISTORY_LIST}`

          return {
            url,
            params: {
              page: payload.page ?? 0,
              size: payload.size ?? 10,
              sortby: payload.sortby ?? 'createdAt',
              sortdir: payload.sortdir ?? 'DESC',
              s: payload.search ?? '',
            },
          }
        },
      }),
      submitDisbursementBatch: builder.mutation({
        query(payload) {
          return {
            url: API_DISBURSEMENT_BATCH,
            method: 'POST',
            body: payload,
          }
        },
        invalidatesTags: ['TeamList', 'DisburseHistory'],
      }),
      getDetailBatch: builder.query({
        query({ batchId }) {
          return {
            url: `${API_DISBURSEMENT_BATCH_DETAIL}/${batchId}`,
          }
        },
      }),
      getDetailBatchList: builder.query({
        query(payload) {
          const { batchId, page, size, search, sortby, sortdir, from, to } =
            payload || {}
          return {
            url: `/${API_DISBURSEMENT_DETAILS}`,
            params: {
              batchId,
              ...(page !== undefined ? { page } : {}),
              ...(size !== undefined ? { size } : {}),
              ...(search ? { s: search } : {}),
              ...(sortby ? { sortby } : {}),
              ...(sortdir ? { sortdir } : {}),
              ...(from ? { from } : {}),
              ...(to ? { to } : {}),
            },
          }
        },
      }),
      getDataAutoLoad: builder.query({
        query({ month, year }) {
          return {
            url: `${API_DISBURSEMENT_AUTO_CALCULATE}?month=${month}&year=${year}`,
          }
        },
      }),
    }
  },
})

export const {
  useFetchEmployeePaymentsListQuery,
  useLazyFetchEmployeePaymentsListQuery,
  useFetchTeamListQuery,
  useLazyFetchTeamListQuery,
  useFetchDisburseHistoryListQuery,
  useLazyFetchDisburseHistoryListQuery,
  useSubmitDisbursementBatchMutation,
  useGetDetailBatchQuery,
  useGetDetailBatchListQuery,
  useGetDataAutoLoadQuery,
  useLazyGetDataAutoLoadQuery,
} = employeePaymentsListApiSlice
